import { EnumSections, MApplication, MAppMeta, MProfile } from './scholarship.models';

export interface IMatchApplicationsState {
  loadingForms: boolean;
  application: MApplication | undefined;
  applicationId: string | undefined;
  applications: MAppMeta[] | undefined;
  applicationsCount: number;
  error: string | undefined;
  parameters: IMatchParameters;
  profiles: MProfile[] | undefined;
  resendEmailStatus?: string;
  sendingEmail?: boolean;
  savingApplication: boolean;
  savingPurchaser: boolean;
  savingProfile: boolean;
  step: number;
  steps: any[];
  stepsCompleted: { [k: number]: boolean };
  addPurchaserError?: string;
}

export interface IMatchParameters {
  search: string;
  showing: string;
  sortField: string;
  sortDirection: string;
  start: number;
  limit: number;
  filter?: string;
}

export const INITIAL_STATE: IMatchApplicationsState = {
  loadingForms: false,
  application: undefined,
  applicationId: undefined,
  applications: undefined,
  applicationsCount: 0,
  profiles: undefined,
  error: undefined,
  savingApplication: false,
  savingPurchaser: false,
  savingProfile: false,
  parameters: {
    search: '',
    showing: 'all',
    sortField: 'id',
    sortDirection: 'asc',
    start: 0,
    limit: 10
  },
  step: 0,
  steps: [
    { id: EnumSections.META, label: 'Profiles', num: 0 },
    { id: EnumSections.TTPF, label: 'TTPF Account', num: 1 },
    { id: EnumSections.FINANCIAL, label: 'Financial', num: 2 },
    { id: EnumSections.ESSAY, label: 'Essay', num: 3 },
    { id: EnumSections.TRANSCRIPT, label: 'Transcript', num: 4 },
    { id: EnumSections.SIGNATURES, label: 'Complete', num: 5 }
  ],
  stepsCompleted: {},
  addPurchaserError: undefined
};
